// Transfer tickets: the routes and the sidebar rows of `dowgate.ops.transfers` (SEP-283, ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const TransferUpdatesCard = lazy(() =>
    import('@/components/transfers/TransferUpdatesCard').then((m) => ({
        default: m.TransferUpdatesCard,
    })),
);

export default defineWebFeature({
    id: 'dowgate.ops.transfers',
    slots: {
        // SEP-317 section 6.1. The tickets with an update that the signed-in
        // Operations user has not read, on the Ops Dashboard. The card reads
        // its tickets inside its component, so the page cannot count them:
        // `count` is null, and the card never collapses and never raises the
        // hidden cue (SEP-296).
        'ops.dashboard.cards': [
            {
                key: 'transfer-updates',
                order: 20,
                span: 6,
                title: 'Transfer updates',
                summary: 'The transfer tickets with an update that you have not read.',
                rows: 5,
                count: () => null,
                emptyBehaviour: 'keep',
                Component: TransferUpdatesCard,
            },
        ],
    },
    routes: [
        {
            frontend: 'desk',
            path: 'transfers',
            lazy: () => import('@/pages/desk/transfers/page'),
        },
        {
            frontend: 'desk',
            path: 'transfers/new',
            lazy: () => import('@/pages/desk/transfers/new/page'),
        },
        {
            frontend: 'desk',
            path: 'transfers/:id',
            lazy: () => import('@/pages/desk/transfers/detail/page'),
        },
        {
            frontend: 'ops',
            path: 'transfers',
            lazy: () => import('@/pages/ops/transfers/page'),
        },
    ],
    nav: [
        {
            // The IM or the EA fills the Transfers Checklist here and follows
            // the ticket that Operations works. The row is open to an
            // im-assistant: the bar list does not name it.
            frontend: 'desk',
            key: 'transfers',
            label: 'Transfers',
            href: '/desk/transfers',
            icon: 'ArrowLeftRight',
            group: 'septima-crm',
            order: 225,
        },
        {
            // Operations receives, works and completes the transfer tickets.
            frontend: 'ops',
            key: 'transfers',
            label: 'Transfers',
            href: '/ops/transfers',
            icon: 'ArrowLeftRight',
            group: 'client-operations',
            order: 415,
        },
    ],
});
